import React, { useEffect, useState, useMemo } from 'react';
import { TablaAxios } from './TablaAxios';
import { TablaN } from './TablaN';
import maximize from '../assets/logo-maximize.png';
import minimize from '../assets/logo-minimize.png';

export const DashboardTable = ({
    id,
    row,
    title,
    url,
    elemNoEncontrado,
    contenidoFilaTabla,
    maximized,
    setMaximized,
    classNameTabla,
    elements,     // 👈 ahora se llama elements
    isLoading     // 👈 loader externo
}) => {

    const [count, setCount] = useState(0);

    useEffect(() => {
        elements && setCount(elements.length)
    }, [elements]);

    useEffect(() => {
        if (!id) return;

        const container = document.getElementById(id);
        if (!container) return;

        const firstLevelChildren = Array.from(container.children);

        firstLevelChildren.forEach(child => {
            const width = child.offsetWidth;
            child.style.minWidth = `${width - 1}px`;
        });

    }, [elements]);

    const isMaximized = maximized === id;

    const isAnotherInSameRow =
        maximized &&
        maximized !== id &&
        (
            (row === 'top' &&
                (maximized === 'empresas' || maximized === 'inscripciones')) ||
            (row === 'bottom' && maximized === 'eventos')
        );

    const toggle = () => {
        setMaximized(prev => (prev === id ? null : id));
    };

    const itemsEncabezado = useMemo(() => ([
        {
            className: 'col text-black',
            text: (
                <>
                    {title}
                    {count > 0 && (
                        <div className="quantityTableControlPanel">
                            {count}
                        </div>
                    )}
                </>
            )
        },
        {
            className: 'col-2 w-auto text-black d-flex',
            text: (
                <img
                    className='cursor-pointer img-blanco-mobile'
                    src={isMaximized ? minimize : maximize}
                    alt=""
                    onClick={toggle}
                />
            )
        }
    ]), [title, count, isMaximized]);

    const computedClassName = `
        ${classNameTabla}
        transition-all-1s
        ${isMaximized
            ? 'flex-1'
            : isAnotherInSameRow
                ? 'flex-0 p-0 overflow-hidden'
                : 'flex-1'
        }
    `;

    const sharedProps = {
        id,
        itemsEncabezado,
        elemNoEncontrado,
        classNameTabla: computedClassName
    };

    if (elements !== undefined) {
        return (
            <TablaN
                {...sharedProps}
                elementos={elements}
                itemsFilas={contenidoFilaTabla}
                mostrarLoader={isLoading}
            />
        );
    }

    return (
        <TablaAxios
            {...sharedProps}
            url={url}
            contenidoFilaTabla={contenidoFilaTabla}
            onDataLoaded={(data) => setCount(data.length)}
        />
    );
};
